module.exports = __webpack_public_path__ + "img/山麦冬.dd9cb786.jpg";